//header
import React from "react";
import styles from "../styles/buttonStyle.js";
import { View, Text,TouchableOpacity } from "react-native";

const CommonButton = (props) => {
  return (
    <View style={styles.paynowBtnView}>
      <TouchableOpacity disabled={props.disabled} onPress={(name) => props.onPress(name)} style={styles.payBtn}>
        <Text style={styles.txtPayNow}>{props.ButtonText}</Text>
      </TouchableOpacity>
    </View>
  );
};

export default CommonButton;
